export default __webpack_public_path__ + "static/media/check-grande.f23eb43a.png";